import { jsx, jsxs } from 'react/jsx-runtime';
import { useEffect } from 'react';
import '../../../../assets/icons/fullScreenExit.svg.mjs';
import '../../../../constants/icons/header/index.mjs';
import '../../../../contexts/MicrositeMenuContext/index.mjs';
import { useMicrositeMenuTranslations } from '../../../../contexts/MicrositeMenuContext/translations.mjs';
import '../../../Button/index.mjs';
import '../../../StyleableSvgImage/index.mjs';
import '../SiteMapColumns/index.mjs';
import '../VisualTopology/index.mjs';
import { Wrap, MenuWrap, MenuInnerWrap, Container, HeaderRow, LogoAnchor, StyledSvgImage, ButtonLabel, FlexColumn } from './SiteMap.styles.mjs';
import { useMicrositeMenu } from '../../../../contexts/MicrositeMenuContext/context.mjs';
import { StyleableSvgImage } from '../../../StyleableSvgImage/StyleableSvgImage.mjs';
import logoUnifi__default from "../../../../assets/logoUnifi.svg";
import { Button } from '../../../Button/Button.mjs';
import FullScreenExit__default from "../../../../assets/fullScreenExit.svg";
import { VisualTopology } from '../VisualTopology/VisualTopology.mjs';
import { SiteMapColumns } from '../SiteMapColumns/SiteMapColumns.mjs';
"use strict";
const SiteMap = ({
  menu,
  show,
  onLinkClick,
  onCloseSitemap
}) => {
  const {
    language
  } = useMicrositeMenu();
  const {
    formatMessage
  } = useMicrositeMenuTranslations(language);
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show]);
  return /* @__PURE__ */jsx(Wrap, {
    children: /* @__PURE__ */jsx(MenuWrap, {
      $motif: "light",
      $slideInView: show,
      children: /* @__PURE__ */jsx(MenuInnerWrap, {
        $shouldShow: show,
        children: /* @__PURE__ */jsxs(Container, {
          size: "desktop",
          noVerticalMargin: true,
          children: [/* @__PURE__ */jsxs(HeaderRow, {
            children: [/* @__PURE__ */jsx(LogoAnchor, {
              onClick: onCloseSitemap,
              children: /* @__PURE__ */jsx(StyleableSvgImage, {
                src: logoUnifi__default,
                width: 46,
                height: 14
              })
            }), /* @__PURE__ */jsxs(Button, {
              variant: "link",
              onClick: onCloseSitemap,
              children: [/* @__PURE__ */jsx(StyledSvgImage, {
                src: FullScreenExit__default,
                height: 20,
                width: 20
              }), /* @__PURE__ */jsx(ButtonLabel, {
                children: formatMessage("menu.siteMap.closeSiteMap")
              })]
            })]
          }), /* @__PURE__ */jsxs(FlexColumn, {
            children: [/* @__PURE__ */jsx(VisualTopology, {
              items: menu,
              onLinkClick
            }), /* @__PURE__ */jsx(SiteMapColumns, {
              items: menu,
              onLinkClick
            })]
          })]
        })
      })
    })
  });
};
export { SiteMap };
//# sourceMappingURL=SiteMap.mjs.map
